import {
  createMultiStyleConfigHelpers,
  MultiStyleType,
  StyleThemingProps,
} from '~/utils/chakraUtils'
import { mergeMultiStyleConfig } from '~/utils/styleHelpers'

import { textStyleKeys } from '@mangovoice/design-system'
import { textStyles } from '@mangovoice/design-system'

const QuickDialListItemParts = [
  'container',
  'textContainer',
  'labelContainer',
  'labelText',
  'subLabelText',
  'buttonsContainer',
] as const

const helpers = createMultiStyleConfigHelpers(QuickDialListItemParts)
export const QuickDialListItemStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      flexShrink: 0,
      justifyContent: 'flex-start',
      alignItems: 'center',
      height: '3.75rem',
      width: 'full',
      paddingX: '0.75rem',
      gap: '0.75rem',
      borderRadius: '0.5rem',
      _hover: {
        backgroundColor: 'bg.muted',
        '& > div.action-buttons': {
          display: 'flex',
        },
      },
    },
    textContainer: {
      flexDirection: 'column',
      justifyContent: 'center',
      gap: '0.25rem',
    },
    labelContainer: {
      alignItems: 'center',
      gap: '0.5rem',
    },
    labelText: {
      ...textStyles[textStyleKeys.Body1],
      color: 'fg.default',
    },
    subLabelText: {
      ...textStyles[textStyleKeys.Body3],
      color: 'fg.muted',
    },
    buttonsContainer: {
      display: 'none',
      gap: '0.25rem',
    },
  },
})

export const useQuickDialListItemStyle = (props?: StyleThemingProps) => {
  return mergeMultiStyleConfig(QuickDialListItemStyle, props) as MultiStyleType<
    typeof QuickDialListItemParts
  >
}
